.beforeQuizContainer {
	display: flex;
	flex-direction: column;
	overflow-x: hidden;
	height: 100vh;
	width: 100vw;
	box-sizing: border-box;
	padding: 1.25rem;
	padding-right: 0; /*UI team wants scrollbar of stepContent to be at the very end*/
	background-color: white;
	position: relative;
}

.beforeQuizModal {
	height: 90vh;
	width: 90vw;
	box-shadow: 0px 0px 20px 5px #6f6f6f40;
	position: fixed;
	top: 5vh;
	left: 5vw;
	border-radius: 1.25rem;
}

.mainContentContainer {
	display: flex;
	flex-direction: row;
	flex: 1;
	gap: 1rem;
	box-sizing: border-box;
	margin: 0.5rem 0;
	overflow: hidden;
	width: 100%;
}

.stepperContainer {
	min-width: 17vw;
	max-width: 17vw;
	height: 100%;
	display: flex;
	flex-direction: column;
	gap: 1rem;
	padding-right: 0.3125rem;
}

.stepContainer {
	overflow-y: auto;
	height: 100%;
	box-sizing: border-box;
}

div.supportContainer {
	position: absolute;
	right: 0;
	top: 0;
	bottom: 0;
	transition: width 0.3s ease;
	pointer-events: none;
	z-index: 10;
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
}

.beforeQuizFooterContainer {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	gap: 0.5rem;

	width: auto;
	/* Negative margin equal to the parent container's padding (1.25rem) */
	margin: 0 -1.25rem -1.25rem -1.25rem;
	padding: 0.937rem 3.4375rem 1.25rem 3.4375rem;

	/* Above done just so border extends all the way to the end because UI team wants border to extend all the way*/
	border-top: 1px solid #b3b3b3;
}

span.disabledWrapper {
	cursor: not-allowed;
}

.footerButton:global(.MuiButton-root) {
	min-width: 132px;
	height: 40px;
}

button.closeButton {
	height: 28px;
	width: 28px;
}

.closeButtonWrapper {
	position: absolute;
	top: 1.25rem;
	right: 1.25rem;
	z-index: 10;
}

.timerContainer {
	width: 100%;
	border-radius: 15px;
	border: 1px solid #e2e2e2;
	background-color: #f4f5fc;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 0.9375rem;
	gap: 0.625rem;

	.timerTitleWrapper {
		display: flex;
		flex-direction: row;
		gap: 0.3125rem;
		align-items: center;
	}

	.timerTitleWrapper p {
		color: #7c5cb2;
		font-weight: 400;
		font-size: 0.875rem;
		line-height: 1.6;
	}

	.timerTitleWrapper svg {
		fill: #7c5cb2;
		width: 20px;
		height: 20px;
	}

	& .timerText {
		font-size: 1.125rem;
		font-weight: 400;
		color: #212121;
		line-height: 1.4;
	}
}

.scrollHintButton:global(.MuiButton-root) {
	border-radius: 10px;
	border: 1px solid #d4cfef;
	box-shadow: 0px 0px 20px 0px #8e98d440;
	box-shadow: 0px 0px 8px 0px #d0d4ed;
	background-color: #f1efff;
	padding: 1rem 2rem;
	position: absolute;
	bottom: 8%;
	display: flex;
	flex-direction: row;
	left: 50%;
	transform: translateX(-50%);
	gap: 0.625rem;
	width: 184px;
	min-width: fit-content;
	justify-content: center;
	align-items: center;
	max-height: 54px;
	cursor: pointer;

	&:focus-visible {
		border: 1px solid var(--focus-outline-color-dark);
	}

	&:hover {
		background-color: #f5f4fb;
	}

	p {
		color: #664ea4;
		font-size: 0.9375rem;
		font-weight: 500;
		line-height: 1.4;
	}

	svg {
		fill: #664ea4;
		width: 24px;
		height: 24px;
		animation: blink-icon 1.5s 3 ease-in-out forwards;
	}
}

@keyframes blink-icon {
	0% {
		opacity: 1;
	}
	50% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}

@media (max-width: 800px) {
	.mainContentContainer {
		flex-direction: column;
		padding-top: 2rem;
	}
	.stepperContainer {
		min-width: unset;
		max-width: unset;
		height: 20vh;
		min-height: 125px;
		overflow-y: auto;
		width: 100%;
	}

	.beforeQuizFooterContainer {
		margin-left: -1.25rem;
		margin-right: 0;
		margin-bottom: -1.25rem;

		width: 100%;
		box-sizing: border-box;
		padding: 0.937rem 2.1875rem 1.25rem 2.1875rem;
	}

	.scrollHintButton:global(.MuiButton-root) {
		width: 190px;
		max-height: 40px;
	}
}
